import { DISALLOWED_COLOR_VALUES as t } from "../../constants.js";
import i from "../../bundled_deps/.pnpm/tinycolor2@1.6.0/bundled_deps/tinycolor2/esm/tinycolor.js";
const f = (r) => {
  if (r) {
    const o = i(r);
    if (o.isValid() && !t.includes(r))
      return o.toHexString();
  }
  return "";
};
export {
  f as getBackgroundColor
};
